module.exports = __webpack_public_path__ + "img/n-4.9ec768a3.png";